import React, { useState } from 'react';
import { Box, Image, Stack, Text } from '@chakra-ui/react';
import { EnlargeIcon } from './icons/icons';

/*
  Recibe la data en forma de objeto con los campos imgLocation, title y subtitle.
*/
function CarouselDescription( { data, size, imgPreview = false, dots = true, banner = true , nroProyecto, enlarge, enlargeIcon = true} ){

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImage, setCurrentImage] = useState(data[0].location);
  const [loaded, setLoaded] = useState(false);
  const [hover, setHover] = useState(false);

  /*
    Selecciona la próxima o anterior imagen en display dentro de los límites del array de imágenes, dependiendo de la dirección indicada por parámetro.
  */
  function move(forward){
    let newIndex;
    if (forward){
      currentIndex === (data.length - 1) ? newIndex = currentIndex : newIndex = currentIndex + 1;
    } else{
      currentIndex === 0 ? newIndex = currentIndex : newIndex = currentIndex - 1;
    }
    goTo(newIndex);
  }

  /*
    Muestra la imagen deseada. No controla que el índice sea correcto, puesto que dicho control se encuentra en el objeto de UI
  */
  function goTo(index){
    // Evitamos animaciones indeseadas
    if (currentIndex !== index) {
      setLoaded(false);
      setTimeout( () => {
      setCurrentIndex(index);
      setCurrentImage(data[index].location);
      }, 600);
    }
  }

  function rangeIndex(index){
    let indexInRange;
    index < 0 ? indexInRange = (data.length + index) : indexInRange = index % data.length;
    return indexInRange;
  }

  /*
    Renderiza la vista de navegación de imágenes por selección de índice simbolizado con puntos.
  */
  function renderDotsNavigationBar(){
    return(
      <Stack direction='row' justifyContent='center' alignItems='center'>
        {data.map((img, index) => (<Text  key={ index } onClick={ () => goTo(index) } fontSize={'2xl'} cursor={'pointer'}
                                          color={ currentIndex === index ? 'grey' : 'black' }
                                          _hover={{ transform: 'scale(1.3);'}}
                                          transitionDuration={'0.2s'}> • </Text>) )}
      </Stack>
    );
  }

  /*
    Renderiza la vista de navegación de imágenes con previews en tamaño reducido
  */
  function renderImagesPreview(){
    return (
      // Êsto está sucio por ahora
      <Stack direction='row' spacing='10%' justifyContent='center' w='70%'>
        <Image src={data.at(currentIndex - 1).location} onClick={() => goTo(rangeIndex(currentIndex - 1))} boxSize={'25%'} cursor='pointer' ></Image>
        <Image src={data[currentIndex].location} boxSize={'25%'} border='1px orange solid' cursor='pointer' ></Image>
        <Image src={data.at((currentIndex + 1).location % data.length)} onClick={() => goTo(rangeIndex(currentIndex + 1))} boxSize={'25%'} cursor='pointer' ></Image> 
      </Stack>
    );
  }

  function renderDescriptionFullScreen(){
    return(
      <Stack direction='column' alignItems='center'>
        <Text fontSize={'xl'}> { data[currentIndex].tit } </Text>
        <Text fontSize={'sm'} display={['none', 'block']}> { data[currentIndex].sub } </Text> 
      </Stack>
    );
  }


  return(
    <Stack direction='column' w={['80vw','80vw',`80vw`,`${size}px`]} h={['30vh','80vh','45vh',`${size * 0.75}px`]} alignItems='center' justifyContent='center' position='relative'>
      
      <Stack  direction='row'
              spacing='3%' 
              alignItems={'center'} 
              my='1%' 
              overflow={'hidden'} 
              onMouseEnter={ () => setHover(true) } onMouseLeave={ () => setHover(false) } 
              position='relative'>

        {/*  Carga 'lazy' */}
        <Image src={require(`./${currentImage}`)} id='current' className={loaded ? "loaded" : ""}
               transition='1s' bgSize='cover' zIndex='1' opacity={ loaded ? 1 : 0}
               onLoad={() => setLoaded(true) }>
        </Image>

        <Box  position='absolute' zIndex='2' left='-1%' 
              onClick={ () => {move(false)} } cursor={'pointer'}
              opacity={currentIndex > 0 ? '0.5' : '0'}
              >

              <Text fontSize={['3xl','5xl','5xl','5xl']} color='grey' fontFamily={'lato'}       
                  _hover={{ transform: 'scale(1.25);'}}
                  transitionDuration={'0.2s'}>{'<'}</Text>
        </Box>

        <Box position='absolute' zIndex='2' right={'10px'} 
             onClick={ () => {move(true)} } cursor={'pointer'}
             opacity={currentIndex < (data.length - 1) ? '0.5' : '0'}
            >

              <Text fontSize={['3xl','5xl','5xl','5xl']} color='grey' fontFamily={'lato'}     
                    _hover={{ transform: 'scale(1.25);'}}
                    transitionDuration={'0.2s'}
                                                > {'>'} </Text>
        </Box>
        
        
        { banner && (
          <Box  w={`${size}px`} minH={'12%'} position='absolute' bottom='0%' right='0%' zIndex='7'
                color='black' opacity={ hover ? '0.91' : '0' } transition='0.7s'
                bgGradient='linear-gradient(0deg, rgba(51,51,51,1) 0%, rgba(204,204,204,1) 100%)'
                display={['none','none','none','block']}
                >
                      <Text pl={['12%','3%']} py='1%' fontSize={'md'}> { data[currentIndex].tit } </Text>

                      { data[currentIndex].sub ? 
                        <Text px={'3%'} pb={'2%'} fontSize={'xs'} display={['none', 'block']}> { data[currentIndex].sub } </Text> 
                        : null
                      }
          </Box>

        ) }
        
      </Stack>

      { imgPreview ? renderImagesPreview() : dots ? renderDotsNavigationBar() : null}
      { !banner && renderDescriptionFullScreen() }

      { enlargeIcon && (
          <Box  position='absolute' zIndex='5' 
          top='1%' right={['1px','1%','1%','1%']}
          cursor='pointer'
          display={['none', 'block']}
          data-proyectonumero={nroProyecto}
          onClick={ (e) => enlarge(e.currentTarget.dataset.proyectonumero) }
          _hover={ { transform: 'scale(1.05);' } }
          >
            <EnlargeIcon/>
          </Box>
        )
      }
      

    </Stack>
  );
}


export default CarouselDescription;